module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"title":"Article Blueprints","tabs":{"ALL":"All","MINE":"Mine"}}}')
  delete Component.options._Ctor
}
